
define('ldsh!modules/form_editor/templates/editor_custom_separator', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-form-group js-label-group">\n  <label\n    for="idElement"\n    data-i18n="formEditor.elementId"\n  >Id del elemento</label>\n  <input\n    id="idElement"\n    type="text"\n    name="idElement"\n    class="form-control js-element-id"\n    value="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n  />\n</div>\n\n<div class="ed-form-group editor-form-group">\n  <label data-i18n="[text]formEditor.separatorHeight">Alto de la separación</label>\n  <input\n    type="number"\n    class="form-control js-height"\n    min="1"\n    step="1"\n    value="' +
((__t = ( height )) == null ? '' : __t) +
'"\n  />\n</div>\n\n<div class="ed-form-group">\n  <div class="md__checkbox--wrapper">\n    <input\n      id="show-hr"\n      name="show-hr"\n      type="checkbox"\n      class="md__checkbox--primary js-show-hr"\n      ' +
((__t = ( showHrChecked ? "checked": "" )) == null ? '' : __t) +
'\n    />\n    <label\n      for="show-hr"\n      data-i18n="formEditor.separatorShowHr"\n    ></label>\n  </div>\n</div>\n\n<div class="ed-form-group editor-form-group ' +
((__t = ( showHr ? '' : 'hidden' )) == null ? '' : __t) +
'">\n  <label data-i18n="[text]formEditor.separatorHrWidth">Ancho de la línea</label>\n  <input\n    type="range"\n    class="form-control range-input js-hr-width"\n    min="1"\n    max="100"\n    value="' +
((__t = ( hrWidth )) == null ? '' : __t) +
'"\n  />\n  <span class="range-label">' +
((__t = ( hrWidth )) == null ? '' : __t) +
'%</span>\n</div>\n\n<div class="ed-form-group editor-form-group ' +
((__t = ( showHr ? '' : 'hidden' )) == null ? '' : __t) +
'">\n  <label data-i18n="[text]formEditor.separatorHrHeight">Alto de la línea</label>\n  <input\n    type="range"\n    class="form-control range-input js-hr-height"\n    min="1"\n    max="' +
((__t = ( height )) == null ? '' : __t) +
'"\n    value="' +
((__t = ( hrHeight )) == null ? '' : __t) +
'"\n  />\n  <span class="range-label">' +
((__t = ( hrHeight )) == null ? '' : __t) +
'px</span>\n</div>\n\n<div class="ed-form-group ' +
((__t = ( showHr ? '' : 'hidden' )) == null ? '' : __t) +
'">\n  <label\n    for="align"\n    class="ed-form-group"\n    data-i18n="[text]formEditor.separatorHrAlign"\n  >Alineación de la línea</label>\n  <select name="align" id="align" class="js-hr-align">\n    <option\n      value="left"\n      data-i18n="[text]formEditor.separatorHrAlignLeft"\n      ' +
((__t = ( hrAlign === 'left' ? 'selected' : '' )) == null ? '' : __t) +
'\n    >Izquierda</option>\n    <option\n      value="none"\n      data-i18n="[text]formEditor.separatorHrAlignCenter"\n      ' +
((__t = ( hrAlign === 'none' ? 'selected' : '' )) == null ? '' : __t) +
'\n    >Centrado</option>\n    <option\n      value="right"\n      data-i18n="[text]formEditor.separatorHrAlignRight"\n      ' +
((__t = ( hrAlign === 'right' ? 'selected' : '' )) == null ? '' : __t) +
'\n    >Derecha</option>\n  </select>\n</div>\n';

}
return __p
};});

